import { StickyStack } from "@/components/shared/sticky-stack";
import { Button } from "@/components/ui/button";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { Skeleton } from "@/components/ui/skeleton";
import type {
  FilterRecord,
  SortVariant,
} from "@/contexts/filters-sort-context";
import { useIsClient } from "@/hooks/use-is-client";

import type { DiscoverFilterFields } from "../discover-sort-constants";
import {
  newlyJoinedFilterConfig,
  newlyJoinedSortConfig,
  topActiveFilterConfig,
  topActiveSortConfig,
  topEarnersSortConfig,
  useDiscoverContext,
} from "./discover-context";

export const DiscoverTopFilters = () => {
  const {
    setCurrentSort,
    updateFilter,
    topActiveEnabled,
    newlyJoinedEnabled,
    topEarnersEnabled,
    onFiltersApply,
    setFilters,
  } = useDiscoverContext();
  const isClient = useIsClient();

  const onActiveClick = () => {
    updateFilter(topActiveFilterConfig as FilterRecord, true);
    setCurrentSort(topActiveSortConfig as SortVariant<DiscoverFilterFields>);
    onFiltersApply();
  };

  const onNewlyJoinedClick = () => {
    updateFilter(newlyJoinedFilterConfig as FilterRecord, true);
    setCurrentSort(newlyJoinedSortConfig as SortVariant<DiscoverFilterFields>);
    onFiltersApply();
  };

  const onTopEarnersClick = () => {
    setFilters([]);
    setCurrentSort(topEarnersSortConfig as SortVariant<DiscoverFilterFields>);
    onFiltersApply();
  };

  if (!isClient) {
    return (
      <StickyStack
        className="
          unforce-radius flex flex-col justify-between gap-4 border-b
          border-border-light bg-background/80 p-0 text-xs backdrop-blur-md
        "
      >
        <ScrollArea>
          <div
            className="
              unforce-radius flex items-center gap-4 border-b
              border-border-light p-4
            "
          >
            <Skeleton className="h-12 w-full" />
            <Skeleton className="h-12 w-full" />
            <Skeleton className="h-12 w-full" />
            <Skeleton className="h-12 w-full" />
          </div>
        </ScrollArea>
      </StickyStack>
    );
  }

  return (
    <StickyStack
      className="
        unforce-radius z-10 flex flex-col justify-between gap-4 border-b
        border-border-light bg-background/80 p-0 text-xs backdrop-blur-md
      "
    >
      <ScrollArea>
        <div className="flex items-center gap-4 p-4">
          <Button
            size="lg"
            variant={topActiveEnabled ? "default" : "outline"}
            onClick={onActiveClick}
          >
            Top Active Users
          </Button>
          <Button
            size="lg"
            variant={newlyJoinedEnabled ? "default" : "outline"}
            onClick={onNewlyJoinedClick}
          >
            Top New Users
          </Button>
          <Button
            size="lg"
            variant={topEarnersEnabled ? "default" : "outline"}
            onClick={onTopEarnersClick}
          >
            Top Earning Users
          </Button>
        </div>
        <ScrollBar orientation="horizontal" />
      </ScrollArea>
    </StickyStack>
  );
};
